import { Card, CardContent, Grid, Typography, TypographyProps } from '@mui/material';
import React from 'react';

export const JobDetailCard: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => (
  <Card
    variant="outlined"
    sx={{
      borderColor: 'divider',
      borderRadius: 1,
      boxShadow: 'none',
    }}
  >
    <CardContent sx={{ p: { xs: 2, sm: 2.5 }, '&:last-child': { pb: { xs: 2, sm: 2.5 } } }}>
      <Grid container direction="column" spacing={2}>
        {children}
      </Grid>
    </CardContent>
  </Card>
);

export const JobDetailSection: React.FC<{
  label: string;
  children: React.ReactNode;
}> = ({ label, children }) => (
  <Grid item>
    <Grid container direction="column" spacing={0.5} sx={{ minWidth: 0 }}>
      <Grid item>
        <Typography variant="body2" color="text.secondary">
          {label}
        </Typography>
      </Grid>
      <Grid item>{children}</Grid>
    </Grid>
  </Grid>
);

export const JobDetailValue: React.FC<{
  children: React.ReactNode;
  variant?: TypographyProps['variant'];
}> = ({ children, variant = 'body1' }) => (
  <Typography variant={variant} sx={{ overflowWrap: 'anywhere' }}>
    {children}
  </Typography>
);
